import { axios } from "../../helper/axios";
import { VehicleConstant } from "./VehicleConstant";


const VehicleApiData = {};

VehicleApiData.getVehicleData = (data) => {
  const { page } = data;

  const queryParams = new URLSearchParams();

  if (page) {
    if (page.from_date && page.to_date) {
      queryParams.append('startDate', page.from_date);
      queryParams.append('endDate', page.to_date);
    }
    if (page.page) queryParams.append('page', page.page);
    if (page.limit) queryParams.append('limit', page.limit);
    if (page.search_term) queryParams.append('search_term', page.search_term);
    if (page.manufacturer) queryParams.append('manufacturer', page.manufacturer);
    if (page.manufacturer_type) queryParams.append('manufacturer_type', page.manufacturer_type);
    if (page.sub_type) queryParams.append('sub_type', page.sub_type);
    if (page.variant_name) queryParams.append('variant_name', page.variant_name);
    if (page.model_name) queryParams.append('model_name', page.model_name);
    if (page.ac_names) queryParams.append('ac_name', page.ac_names);
    if (page.dc_names) queryParams.append('dc_name', page.dc_names);
    if(page.sort) queryParams.append('sort', page.sort)
  }

  return axios.get(`${VehicleConstant.VEHICLE_API}?${queryParams.toString()}`);
};



VehicleApiData.ExportBulk = ({limit}) => {
    let queryParam = "";

    if (limit !== undefined && limit !== null) {
      queryParam += `limit=${limit}`;
    }
        return axios.get(`${VehicleConstant.VEHICLE_API}?${queryParam}`);
}



VehicleApiData.postVehicleData = ( payload ) => {
    return axios.post(
        VehicleConstant.ADD_VEHICLE_API, payload
    );
  }


  VehicleApiData.getVehicleDropdownData = () => {
        return axios.get(VehicleConstant.VEHICLE_DROPDOWN_API)
}

VehicleApiData.getVehicleTypeData = () => {
  return axios.get(VehicleConstant.VEHICLE_TYPES_API)
}

VehicleApiData.getVehicleSubTypeData = (payload) => {   
  const variant_id = payload;   
  let queryParam = "";   
  if (variant_id !== undefined && variant_id !== null) {     
    queryParam += `variant_id=${variant_id}`;   
  }   
  return axios.get(`${VehicleConstant.VEHICLE_SUB_TYPES_API}/?${queryParam}`);
}


VehicleApiData.postVehicleBulkApi = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axios.post(VehicleConstant.POST_VEHICLE_BULK_API,formData );
};

VehicleApiData.VehicleMenufaturerbyIdapi = ({payload} ) => {
  const type_id=payload;
  let queryParam = "";
  if (type_id !== undefined && type_id !== null) {
    queryParam += `type_id=${type_id}`;
  }
  return axios.get(
    `${VehicleConstant.VEHICLE_GET_MENUFATURER_API}/?${queryParam}`
  );
};
  
VehicleApiData.VehicleModelbyIdapi = ({payload} ) => {
  return axios.get(
    `${VehicleConstant.VEHICLE_MODEL_API}/${payload}`
  );
};

VehicleApiData.VehicleVariantapi = ({payload}) => {
const {manufacturer_id,model_id}=payload;

  let queryParam = "";
  if ( manufacturer_id!== undefined && manufacturer_id !== null) {
    queryParam += `manufacturer_id=${  manufacturer_id}&`;
  }
  if (model_id !== undefined && model_id !== null) {
    queryParam += `model_id=${model_id}`;
  }
 
  return axios.get(
    `${VehicleConstant.VEHICLE_VARIANT_DROPDOWN_API}/?${queryParam}`
  );
};
VehicleApiData.DeleteConnectorApi = ({ id }) => {
  
  return axios.delete(
    VehicleConstant.DELETE_VEHICLE_API.replace(":id", id)
  );
};


VehicleApiData.UpdateVehicle = (id, payload) => {
  return axios.put(
    VehicleConstant.UPDATE_VEHICLE_API.replace(":id", id),
    payload
  );
};


export { VehicleApiData };
